import { render } from "./ReportingWindows.vue?vue&type=template&id=1fe9f013"
import script from "./ReportingWindows.vue?vue&type=script&lang=js"
export * from "./ReportingWindows.vue?vue&type=script&lang=js"
script.render = render

export default script